import RoleDashboardLayout from '../../components/RoleDashboardLayout';
import { StaffWorkbenchContent } from '../../components/accountant/StaffWorkbenchContent';

export default function StaffWorkbenchPage() {
  return (
    <RoleDashboardLayout role="accountant">
      <StaffWorkbenchContent />
    </RoleDashboardLayout>
  );
}